export class OrgSearch {
  value: string
  column: string

  constructor(item: OrgSearch) {
    this.value = item.value
    this.column = item.column
  }

  static empty = (): OrgSearch =>
    new OrgSearch({
      value: '',
      column: 'All',
    })
}

export interface IOrgFilter {
  paging: {
    pageIndex: number
    pageSize: number
  }
  filter?: OrgFilter
  sort?: {
    column: string
    direction: string
  }
  search?: {
    value: string
    column: string
  }
}

export class OrgFilter {
  name: string
  type: string
  description: string
  stakeholderId: string
  programGroup: string
  programGroupIds: number[]
  typeIds?: number[]
  orgIds?: number[]

  constructor(item: OrgFilter) {
    this.programGroupIds = item.programGroupIds
    this.stakeholderId = item.stakeholderId
    this.description = item.description
    this.name = item.name
    this.programGroup = item.programGroup
    this.type = item.type
    this.orgIds = item.orgIds
  }

  public static empty = (): OrgFilter =>
    new OrgFilter({
      programGroupIds: [],
      description: '',
      stakeholderId: '',
      type: null,
      typeIds: null,
      programGroup: '',
      name: ''
    })
}

export interface IOrgSearchResponse {
  data: OrgListItem[]
  paging: {
    pageIndex: number
    pageSize: number
    totalItems: number
  }
  sort: {
    column: string
    direction: string
  }
}

export class OrgListItem {
  rId: number
  name: string
  type: number
  typeName?: string
  description?: string
  stakeholderIds?: string
  programs?: string
  hasIpRestrictions?: boolean
  creationDate?: string
  modificationDate?: string
}

export class Org {
  rId: number
  name: string
  type: number
  typeName?: string
  description?: string
  hasIpRestrictions?: boolean
  creationDate?: string
  modificationDate?: string
}

export class OrgInfo {
  rId: number
  name: string
  type: OrgType
  enableIpRestriction: boolean
  emailDomainRestrictions: string[]
  ipRestrictions: IpRestriction[]
}

export class ProgramCardArt {
  rId: number
  OrgRId?: number
  operatorConfigRId?: number
  programGroup: string
  programCodes: ProgramCodeArt[]
  cardArtUrl?: string
  isChecked?: boolean = false
}

export class ProgramCodeArt {
  rId: number
  programCode: string
  cardArtUrl: string
  isChecked?: boolean = false
}

export class IpRestriction {
  rId: number
  version: IpType
  range: string
}

export class OrgIpRestrictionModel {
  enableIpRestriction: boolean
  ipRestrictions: IpRestriction[]
}

export enum IpType {
  IpV4 = 'IpV4',
  IpV6 = 'IpV6'
}

export enum OrgType {
  Operator = 1,
  Bank = 2,
  Internal = 3
}

export class ProgramCardPackageElligibility {
  cardPackages: CardPackageLookup[]
  customerCardPackage: CardPackage
}

export class CardPackageLookup {
  rId: number
  programCode: string
  cardPackageId: string
  crbCardDesignId: string
  isDefault: boolean
  fee: number
}

export class CardPackage {
  rId: number
  merchantCode: string
  merchantMemberNumber: string
  cardPackageId: string
}